import { useState } from "react";

import ChevronDown from "@/assets/icons/chevron-down.svg";
import ChevronUp from "@/assets/icons/chevron-up.svg";
import { cx } from "@/utils";

import styles from "./Similar.module.css";

const CompactMention = ({
  className,
  episode_pk,
  episode_title,
  content,
  channel_title,
}) => {
  return (
    <div className={cx(styles.compact, className)} data-episode-id={episode_pk}>
      <h2>{channel_title}</h2>
      <h4 dangerouslySetInnerHTML={{ __html: episode_title }} />
      <p dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

const Similar = (props) => {
  const [showSimilar, setShowSimilar] = useState(false);

  const similarMentions = props.mentions.map((m) => (
    <li key={m.uuid}>
      <a
        href={m.mention_link}
        className={styles.link}
        target="_blank"
        rel="noreferrer"
      >
        <CompactMention
          channel_title={m.channel_title}
          episode_title={m.episode_title}
          content={m.content}
          className="similar-mention" // used for testing
          episode_pk={props.episode_pk}
        />
      </a>
    </li>
  ));
  return (
    <div
      className={`similar-mentions ${props.className}`}
      data-testid="test-similar-mentions"
    >
      <a
        className={cx(styles.expand, "expand-similar-mentions")}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setShowSimilar(!showSimilar);
        }}
      >
        {showSimilar ? <ChevronUp height={15} /> : <ChevronDown height={15} />}{" "}
        {`${props.mentions.length} ${
          props.mentions.length > 1
            ? L.MENTIONS_SIMILAR_LINK_PLURAL
            : L.MENTIONS_SIMILAR_LINK_SINGULAR
        }`}
      </a>
      {showSimilar && <ul className={styles.list}>{similarMentions}</ul>}
    </div>
  );
};

export default Similar;
